import { MessagingHelper } from "../helpers/MessagingHelper";
import { LookupDTO } from "../models/Lookup/LookupDTO";
import { APIService } from "./APIService";

export class LookupService {
    /**
     * Get lookups by type
     * @param type The lookup type (e.g., 'ResponsavelDanos', 'ProblemaRelatado', etc.)
     */
    public async GetLookupsByType(type: string): Promise<MessagingHelper<LookupDTO[]>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Lookups/${type}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            // With Axios, response data is directly available in response.data
            return new MessagingHelper<LookupDTO[]>(response.data.success, response.data.message, response.data.obj);
        } catch (error) {
            console.error('Error fetching lookups:', error);
            return new MessagingHelper<LookupDTO[]>(false, "Erro inesperado ao carregar lookups", []);
        }
    }

    /**
     * Get all lookup types available
     */
    public async GetLookupTypes(): Promise<string[]> {
        return [
            'ActivityStatus',
            'UnsuccessfulReason', 
            'Purpose',
            'Fault',
            'Location',
            'Reason',
            'Correction',
            'EquipmentStatus'
        ];
    }
}
